import { useEffect } from "react"

export default function AunityRedirect(){
    useEffect(()=>{
        window.location.replace("https://armx.postperty.com/register")
    },[])
    return(
        <main >Redirect To Aunity</main>
    )
}